/**
 * Callback ref for the Clicks grid's <tbody>. Keeps --pin-max on the table -
 * how far the pinned header may slide down (index.css, .clicks-pin-head) -
 * equal to the body's height as rows load, page or expand.
 */
export function trackBodyHeight(body: HTMLTableSectionElement | null): (() => void) | undefined {
  const table = body?.parentElement;
  if (!body || !table) return;
  if (import.meta.env.DEV) warnIfPinBlocked(body);
  const observer = new ResizeObserver(() =>
    table.style.setProperty("--pin-max", `${body.offsetHeight}px`),
  );
  observer.observe(body);
  return () => observer.disconnect();
}

/**
 * Dev only. The pin rides a view timeline on the page's own scroll, so an
 * ancestor that is a scroll container (overflow auto / scroll / hidden)
 * captures the timeline and the header silently stops pinning. Name it.
 * <body> and <html> are not checked: their overflow goes to the viewport.
 */
function warnIfPinBlocked(body: Element): void {
  if (typeof CSS === "undefined" || !CSS.supports("animation-timeline: view()")) return;
  let el = body.closest(".clicks-pin-scope")?.parentElement ?? null;
  while (el && el !== document.body && el !== document.documentElement) {
    const { overflowX, overflowY } = getComputedStyle(el);
    if (![overflowX, overflowY].every((o) => o === "visible" || o === "clip"))
      console.error("[clicks-pin] this ancestor scrolls, so the Clicks header will not pin:", el);
    el = el.parentElement;
  }
}
